"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogClose = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A wrapper for `Dialog` close button content.
 *
 * @related [`Dialog`]
 * @since 8.54.0
 */
var DialogClose = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "DialogClose",
  componentId: "c11n-8-107-0__sc-148f3kv-0"
})([""]);
exports.DialogClose = DialogClose;
DialogClose.displayName = 'DialogClose';

/** @component */